import { styled } from "@mui/material/styles";

// Components
import { FormControlLabel, Checkbox as MCheckbox } from "@mui/material";

// Themes
import theme from "~/components/Common/Theme";

const styledName = "FormCheckbox";

export const StyledFormItem = styled(FormControlLabel, { name: styledName })({
  "&": {
    height: "30px",
    margin: 0,
    ".MuiFormControlLabel-label": {
      fontSize: "1.6rem",
    },
  },
});

export const StyledCheckbox = styled(MCheckbox, { name: styledName })({
  "&": {
    ".MuiSvgIcon-root": {
      height: "20px",
      width: "20px",
      borderRadius: "5px",
      color: theme.palette.primary.main,
    },
  },
});
